<template>
  <div class="">
    <nstl-header :isShowLogin="isShowLogin" :baseReuqestUrl="baseReuqestUrl" @nstlUserLogin="nstlUserLogin" @nstlUserLogout="nstlUserLogout" :userName="userName" :isLogin="isLogin"> </nstl-header>
    <nstl-aside
      :isLogin="isLogin"
      :isCardUser="isCardUser"
      :isGroupUser="isGroupUser"
      :cartNumber="cartNumber"
      :baseReuqestUrl="baseReuqestUrl"
      :isBind="isBind"
      @isBindClick="isBindClick"
    ></nstl-aside>
    <router-view @nstlUserLogin="nstlUserLogin" ref="child"></router-view>
    <nstl-footer :baseReuqestUrl="baseReuqestUrl" :websiteData="websiteData"></nstl-footer>
    <div class="el-dialog-bg" v-show="dialogVisible">
      <!-- <el-dialog
    
      title=""
      :visible.sync="dialogVisible"
      width="853px"
      :close-on-click-modal ="false"
      left="100vh"
      >-->
      <iframe :src="loginUrl" frameborder="0" width="853px" height="774px" class="frameStyle"></iframe>
      <!--   </el-dialog> -->
    </div>
  </div>
</template>
<style scoped>
.frameStyle {
  position: absolute;
  inset: 0px;
  margin: auto;
  border: 0px;
}
.el-dialog-bg {
  text-align: center;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  border: 0px;
  z-index: 999;
}
</style>
<script>
import Pubsub from 'pubsub-js'
export default {
  components: {},
  name: 'App',
  data() {
    return {
      loginUrl: '',
      dialogVisible: false,
      userInfo: null,
      isShowLogin: true,
      isShowHotline: true,
      serviceHotline: [],
      baseReuqestUrl: '',
      userName: '',
      isLogin: false, //是否已经登录
      cartNumber: 0, //购物车数量
      isGroupUser: false,
      isCardUser: false,
      token: '',
      isBind: true,

      websiteData: {
        tel: '',
        email: '',
        address: '',
        viewsNum: '页面总访问量：0',
      },
    }
  },
  methods: {
    /**跳转登录 */
    nstlUserLogin() {
      //this.$user.login()
      this.loginUrl = 'https://login.nstl.gov.cn'
      this.dialogVisible = true
    },
    /**退出 */
    nstlUserLogout() {
      this.$http.get('/sso/logout.shtml').then((response) => {
        if (response.data == 200) {
          this.$cookie.delete('C', { path: '/', domain: '.nstl.gov.cn' })
          this.$cookie.delete('cartnlg', { path: '/', domain: '.nstl.gov.cn' })
          this.isLogin = false
          this.$store.commit('setIsLogin', false)
          this.$store.commit('setUser', {})
          location.href = this.$store.state.home
        }
      })
    },
    /**获取用户信息 */
    getUser() {
      let that = this
      this.$http.get('/cart/validateUser.shtml').then((response) => {
        if (response.data.code == 0) {
          that.isLogin = true
          that.$store.commit('setIsLogin', true)
          that.userInfo = response.data.data.userInfo
          if (that.userInfo.isbind == '0') {
            that.isBind = false
          }
          that.userName = that.userInfo.username == undefined || that.userInfo.username == '' ? that.userInfo.mobilephone : that.userInfo.username
          if (!that.userName) {
            that.userName = that.userInfo.userid
          }

          that.userName = unescape(that.userName.replace(/\\u/g, '%u'))
          that.$store.commit('setUser', response.data.data.userInfo)
          if (response.data.data.userInfo.usertype == '卡用户') {
            this.isCardUser = true
          }
          if (response.data.data.userInfo.usertype == '企业集团用户' || response.data.data.userInfo.usertype == '公益集团用户') {
            this.isCardUser = true
          }
          that.$nextTick(() => {
              if (that.userInfo.userAuth == 'VIP特许') {  //VIP特许用户隐藏充值菜单
                $("i[class='iconfont_nstl_common icon-chongzhi']").parent().parent().hide()
              }
          })
          
          //验证用户状态，跳转
        } else {
          that.$store.commit('setUser', null)
        }
        if (response.data.msg) {
          that.$message
            .confirm(response.data.msg, '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              type: 'warning',
              center: false,
            })
            .then(() => {
              if (response.data.data.redirectUrl) {
                location.href = response.data.data.redirectUrl
              }
            })
        } else {
          if (response.data.data) {
            that.$store.commit('setDrainage', response.data.data.flag)
            //  this.$store.commit('setArticleType', response.data.data.atype)
            that.$store.commit('setArticleCount', response.data.data.dcount)
          }
        }
        Pubsub.publish('uover', true)
      })
      this.$http.get('/cart/haveInstutionRules.shtml').then(response => {
        if (response.data.code == 0) {
          that.$store.commit('setIsExternal', response.data.data)
        }
      })
    },
    /**获取站点信息 */
    getLib() {
      // let host = this.$cookie.get("nstl_rsp")
      // if(host){
      //    host = host.
      //    https://www.nstl.gov.cn/
      //}
      //let u = "https://www.nstl.gov.cn/api/service/nstl/web/execute?target=nstl4.search4&function=storage/website/url&url=cd.nstl.gov.cn";
      this.$http.get('/cart/getlib.shtml').then((response) => {
        this.$store.commit('setHome', response.data.data)
        let netUrl = response.data.data.libNetAdd
        this.baseReuqestUrl = netUrl
        this.websiteData.tel = response.data.data.libTel
        this.websiteData.email = response.data.data.email
        this.websiteData.address = response.data.data.libAddress
        this.websiteData.name = response.data.data.libCodeName
        let that = this
        $.ajax({
          url: netUrl + '/api/service/nstl/web/execute?target=nstl4.visit&function=pageAccesses/all',
          type: 'get',
          async: true,
          timeout: 5000,
          dataType: 'json',
          success: function (data) {
            that.websiteData.viewsNum = '页面总访问量：' + data
          },
        })
      })
    },
    //改变购物车数量
    cartNumChange() {
      let that = this
      Pubsub.subscribe('cartCount', (name, context) => {
        that.$cookie.set('C', context, { expires: '1Y', path: '/', domain: '.nstl.gov.cn' })
        that.cartNumber = context
        if (context == 0) {
          this.$cookie.set('cartnlg', '', { expires: '1Y', path: '/', domain: '.nstl.gov.cn' })
          return
        }
      })
      if (that.cartNumber == 0 && that.$cookie.get('C') != undefined) {
        that.cartNumber = that.$cookie.get('C')
      }
    },
    isBindClick(url) {
      this.$nextTick(() => {
        this.$refs.child.hasBound()
      })
    },
  },
  mounted() {
    let that = this
    window.addEventListener(
      'message',
      (e) => {
        if (e.data == 'closeLogin') {
          that.loginUrl = ''
          that.dialogVisible = false
        }
        if (e.data == 'SUCCESS') {
          location.reload()
        }
      },
      true
    )

    this.getUser()
    this.getLib()
    this.cartNumChange()
    this.$nextTick(() => {
      const layui = window.layui // 在文件中导入layui模块
      // 网站底部的四栏链接～～
      layui.use('dropdown', function () {
        var dropdown = layui.dropdown
        dropdown.render({
          elem: '#memberUnit_list', //可绑定在任意元素中，此处以上述按钮为例
          trigger: 'hover',
          align: 'center',
          className: 'nstl_dropdown',
          style: 'width: 240px;box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;font-size: 14px;',
          data: [
            { title: '中国科学院文献情报中心', href: 'http://www.las.ac.cn', target: '_blank' },
            { title: '中国科学技术信息研究所', href: 'http://www.istic.ac.cn/', target: '_blank' },
            { title: '机械工业信息研究院', href: 'http://www.gmachineinfo.com/', target: '_blank' },
            { title: '冶金工业信息标准研究院', href: 'http://www.metalinfo.com.cn/', target: '_blank' },
            { title: '中国化工信息中心', href: 'http://www.cncic.cn/', target: '_blank' },
            { title: '中国农业科学院农业信息研究所', href: 'http://aii.caas.net.cn/', target: '_blank' },
            { title: '中国医学科学院医学信息研究所', href: 'http://www.imicams.ac.cn/', target: '_blank' },
            { title: '中国标准化研究院国家标准馆', href: 'https://www.nssi.org.cn/', target: '_blank' },
            { title: '中国计量科学研究院文献馆', href: 'http://www.nim.ac.cn/', target: '_blank' },
            // { title: '中国科学院文献情报中心', href: 'javascript:;'  },
            // { title: '中国科学技术信息研究所', href: 'javascript:;'},
            // { title: '机械工业信息研究院', href: 'javascript:;'},
            // { title: '冶金工业信息标准研究院', href: 'javascript:;' },
            // { title: '中国化工信息中心', href: 'javascript:;' },
            // { title: '中国农业科学院农业信息研究所', href: 'javascript:;' },
            // { title: '中国医学科学院医学信息研究所', href: 'javascript:;' },
            // { title: '中国标准化研究院国家标准馆', href: 'javascript:;'},
            // { title: '中国计量科学研究院文献馆', href: 'javascript:;' },
          ],
          //菜单被点击的事件
           click: function (obj) {
          //   // layer.msg('回调返回的参数已显示再控制台');
          //   // 发送日志参数
             try {
               var _data = {
                 type: 'select-nav',
                 text: obj.title,
               }
               sendOtherLog(_data)
             } catch (error) {}
           },
        })
      })
      layui.use('dropdown', function () {
        var dropdown = layui.dropdown
        dropdown.render({
          elem: '#serviceStation_list', //可绑定在任意元素中，此处以上述按钮为例
          trigger: 'hover',
          align: 'center',
          className: 'nstl_dropdown',
          style: 'width: 240px;box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;max-height: 500px;overflow-y: scroll;overflow-x: hidden;font-size: 14px;',
          data: [
            { title: '中心站', href: 'https://www.nstl.gov.cn/' },
            { title: '兰州服务站', href: 'https://lz.nstl.gov.cn/' },
            { title: '成都服务站', href: 'https://cd.nstl.gov.cn/' },
            { title: '哈尔滨服务站', href: 'https://hrb.nstl.gov.cn/' },
            { title: '西安服务站', href: 'https://xa.nstl.gov.cn/' },
            { title: '昆明服务站', href: 'https://km.nstl.gov.cn/' },
            { title: '南京服务站', href: 'https://nj.nstl.gov.cn/' },
            { title: '郑州服务站', href: 'https://zz.nstl.gov.cn/' },
            { title: '杭州服务站', href: 'https://hz.nstl.gov.cn/' },
            { title: '天津服务站', href: 'https://tj.nstl.gov.cn/' },
          // { title: '青岛服务站', href: 'https://qd.nstl.gov.cn/' },
            { title: '苏州服务站', href: 'https://sdll.nstl.gov.cn/' },
            { title: '广州服务站', href: 'https://gz.nstl.gov.cn/' },
            { title: '西宁服务站', href: 'https://xn.nstl.gov.cn/' },
            { title: '南宁服务站', href: 'https://nn.nstl.gov.cn/' },
            { title: '武汉服务站', href: 'https://wh.nstl.gov.cn/' },
            { title: '宁波服务站', href: 'https://nb.nstl.gov.cn/' },
            { title: '合肥服务站', href: 'https://hf.nstl.gov.cn/' },
            { title: '深圳服务站', href: 'https://sz.nstl.gov.cn/' },
            { title: '长春服务站', href: 'https://jl.nstl.gov.cn/' },
            { title: '泰达服务站', href: 'https://tedala.nstl.gov.cn/' },
            { title: '交通运输服务站', href: 'https://jtys.nstl.gov.cn/' },
            { title: '南昌服务站', href: 'https://jx.nstl.gov.cn/' },
            { title: '石家庄服务站', href: 'https://sjz.nstl.gov.cn/' },
            { title: '银川服务站', href: 'https://yc.nstl.gov.cn/' },
            { title: '成都高新区服务站', href: 'https://cdgx.nstl.gov.cn/' },
            { title: '武汉东湖服务站', href: 'https://whdh.nstl.gov.cn' },
            { title: '长沙服务站', href: 'https://cs.nstl.gov.cn' },
            { title: '福州服务站', href: 'https://fz.nstl.gov.cn' },
            /* { title: '电子科技服务站', href: 'https://dzkj.nstl.gov.cn' }, */
            { title: '拉萨服务站', href: 'https://lhasa.nstl.gov.cn' },
          //  { title: '乌鲁木齐服务站', href: 'https://wlmq.nstl.gov.cn/' },
            { title: '济南服务站', href: 'https://jn.nstl.gov.cn/' },
            { title: '太原服务站', href: 'https://ty.nstl.gov.cn/' },
            { title: '济宁高新区服务站', href: 'https://jngx.nstl.gov.cn/' },
            { title: '新疆兵团服务站', href: 'https://shz.nstl.gov.cn/' },
            { title: '呼和浩特服务站', href: 'https://hsgx.nstl.gov.cn/' },
            { title: '沈阳服务站', href: 'https://sy.nstl.gov.cn/' },
            { title: '贵阳服务站', href: 'https://gy.nstl.gov.cn/' },
            { title: '兰白试验区服务站', href: 'https://lb.nstl.gov.cn/' },
            { title: '海南服务站', href: 'https://hn.nstl.gov.cn/' },
            { title: '中医药服务站', href: 'https://zykxy.nstl.gov.cn/' },
            { title: '地学服务站', href: 'https://dx.nstl.gov.cn/' },
            /* { title: '林草服务站', href: 'https://lc.nstl.gov.cn/' }, */
            { title: '生态环境服务站', href: 'https://sthj.nstl.gov.cn' },
           // { title: '西藏农牧服务站', href: 'https://xznm.nstl.gov.cn' },
          ],
          //菜单被点击的事件
          click: function (obj) {
            // layer.msg('回调返回的参数已显示再控制台');
            // 发送日志参数
            try {
              var _data = {
                type: 'select-nav',
                text: obj.title,
              }
              sendOtherLog(_data)
            } catch (error) {}
          },
        })
      })
      layui.use('dropdown', function () {
        var dropdown = layui.dropdown
        dropdown.render({
          elem: '#friendshipLinks_list', //可绑定在任意元素中，此处以上述按钮为例
          trigger: 'hover',
          align: 'center',
          className: 'nstl_dropdown',
          style: 'width: 240px;box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;font-size: 14px;',
          data: [
            { title: '中国科技资源共享网', href: 'https://escience.org.cn/', target: '_blank' },
            { title: '国家图书馆', href: 'http://www.nlc.cn/', target: '_blank' },
            { title: '中国高等教育文献保障系统', href: 'http://www.calis.edu.cn/', target: '_blank' },
            { title: '国家科技报告服务系统', href: 'http://www.nstrs.cn/', target: '_blank' },
            { title: '中华人民共和国科学技术部', href: 'https://www.most.gov.cn/index.html', target: '_blank' },
            { title: '中国科学技术协会', href: 'https://www.cast.org.cn/', target: '_blank' },
            { title: '中国科学院', href: 'https://www.cas.cn/', target: '_blank' },
          ],
          //菜单被点击的事件
          click: function (obj) {
            // layer.msg('回调返回的参数已显示再控制台');
            // 发送日志参数
            try {
              var _data = {
                type: 'select-nav',
                text: obj.title,
              }
              sendOtherLog(_data)
            } catch (error) {}
          },
        })
      })
      layui.use('dropdown', function () {
        var dropdown = layui.dropdown
        dropdown.render({
          elem: '#featuredSitelinks_list', //可绑定在任意元素中，此处以上述按钮为例
          trigger: 'hover',
          align: 'center',
          className: 'nstl_dropdown',
          style: 'width: 240px;box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;font-size: 14px;',
          data: [
            { title: '国外医学新书评介', href: 'http://bookreview.imicams.ac.cn/', target: '_blank' },
            { title: '国外农业科技新书评介', href: 'http://www.nais.net.cn/publish/default/xspj/', target: '_blank' },
            { title: '院士著作馆', href: 'http://www.istic.ac.cn/nstl-Academician.aspx', target: '_blank' },
          ],
          //菜单被点击的事件
          click: function (obj) {
            // layer.msg('回调返回的参数已显示再控制台');
            // 发送日志参数
            try {
              var _data = {
                type: 'select-nav',
                text: obj.title,
              }
              sendOtherLog(_data)
            } catch (error) {}
          },
        })
      })
    })
  },
  computed: {},
  beforeUpdate() {
    document.querySelector('body').setAttribute('style', 'margin:0px;padding-left:40px;') //取消body的margin和padding
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  },
  watch: {
    //监视当前路由路径，控制显示哪些模块
    $route(to, from) {
      this.headerLoginIsshow = true
      this.leftMenuIsshow = true
      this.navbarIsshow = true
    },
  },
}
</script>

<style >
@import '../static/cart/css/base.css';
@import '../static/cart/css/cart.css';
@import '../static/common/css/iconfont.css';
</style>



// WEBPACK FOOTER //
// src/App.vue